"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toError = toError;
exports.toErrorWithErrorCode = toErrorWithErrorCode;
const generic_helpers_1 = require("./generic.helpers");
function toError(err) {
    if (err instanceof Error) {
        return err;
    }
    if (typeof err === "object" &&
        err !== null &&
        (0, generic_helpers_1.hasOwnProperty)(err, "message")) {
        const error = new Error(String(err.message));
        if ((0, generic_helpers_1.hasOwnProperty)(err, "name")) {
            error.name = String(err.name);
        }
        return error;
    }
    return new Error(String(err));
}
function toErrorWithErrorCode(err) {
    const error = toError(err);
    if (typeof err === "object" &&
        err !== null &&
        (0, generic_helpers_1.hasOwnProperty)(err, "errorCode")) {
        error.errorCode = String(err.errorCode);
    }
    return error;
}
//# sourceMappingURL=error.helpers.js.map